import React from "react";

function SelectInput (props: {
    labelName: string | undefined,
    inputName: string | undefined,
    value: string | number | undefined,
    options: { ID: string | number, Name: string }[],
    errorMessage: string | undefined,
    disabled?: boolean,
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    placeholder?: string | undefined,
}){


    return (
        <div className="mb-2">
            <label>
                <p className="text-gray-500">
                    {props.labelName}
                </p>
            </label>
            <select
                className={`border-gray-400 bg-white w-full focus:border-blue-900 focus:outline-none border-2 p-2 min-h-[12px] shadow-[0_4px_10px_rgba(0,0,0,0.03)] font-normal transition-colors rounded-lg [&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400 ${props.disabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                name={props.inputName || ''}
                onChange={props.onChange}
                value={props.value || ''}
                disabled={props.disabled}
            >
                <option key="0" value={0}>Selecteer een optie</option>
                {props.options && props.options.map((option) => (
                    <option key={option.ID} value={option.ID}>{option.Name}</option>
                ))}
            </select>
            <span className="mt-1 hidden text-sm text-red-400">
                   {props.errorMessage}
            </span>
        </div>

    );
}

export default SelectInput;